import { PlanCargoService } from './../../../_services/plan-cargo.service';
import { AutenticacionService } from './../../../_services/autenticacion.service';
import { NavService } from './../../../_services/_nav.service';
import { Funcionalidad } from './../../../_models/funcionalidad';
import { PlanCargo } from './../../../_models/plan-cargo';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { Router } from '@angular/router';

@Component({
  selector: 'app-planes-cargos-listados',
  templateUrl: './planes-cargos-listados.component.html',
  styleUrls: ['./planes-cargos-listados.component.css'],
})
export class PlanesCargosListadosComponent implements OnInit {
  planesCargos: PlanCargo[] = [];
  carPlanesCargos = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();

  constructor(
    private planCargoService: PlanCargoService,
    private navServicio: NavService,
    private autServicio: AutenticacionService,
    private router: Router
  ) {}

  ngOnInit(): void {
    const mn = this.autServicio
      .obtenerFuncionalidades()
      .find((x) => x.ruta === 'apl/plan-cargo');
    if (mn) {
      this.menu = mn;
    }

    this.columnas = [
      {
        field: 'codigo',
        header: this.navServicio.buscarMensaje('CANALES.LBL_CODIGO'),
        sort: false,
      },
      {
        field: 'nombre',
        header: this.navServicio.buscarMensaje('CANALES.LBL_NOMBRE'),
        sort: true,
      },
      {
        field: 'indicadorHabilitado',
        header: this.navServicio.buscarMensaje('CANALES.LBL_HABILITADO'),
        sort: true,
      },
      {
        field: 'det',
        header: this.navServicio.buscarMensaje('LBL_ACCIONES'),
        sort: false,
      },
    ];
    this.busqueda = this.navServicio.getSearch('plan-cargo.component');

    this.planCargoService.listado().subscribe((planesCargos) => {
      this.planesCargos = planesCargos;
      this.carPlanesCargos = false;
      this.tabla.filterGlobal(this.busqueda, 'contains');
    });
  }

  crearCanal() {
    this.router.navigate(['apl/plan-cargo/agregar']);
  }

  verCanal(planCargo: PlanCargo) {
    this.router.navigate(['apl/plan-cargo/detalle/' + planCargo.idPlanCargo]);
  }

  editarCanal(planCargo: PlanCargo) {
    this.router.navigate(['apl/plan-cargo/actualizar/' + planCargo.idPlanCargo]);
  }

  setBusqueda() {
    this.navServicio.setSearch('plan-cargo.component', this.busqueda);
  }
}
